import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole') || 'clerk'; // Default to clerk if role is empty

  // Simple token/role check
  if (!token || !userRole) {
    return <Navigate to="/login" />;
  }

  // Cus-admin have access to all routes
  if (userRole === 'cus-admin') {
    return children;
  }

  // Check if user has permission for this route
  if (!allowedRoles.includes(userRole)) {
    // Redirect riders to riders portal, others to home
    return <Navigate to={userRole === 'rider' ? '/riders-portal' : '/'} />;
  }

  return children;
};

export default RoleBasedRoute; 